import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type EntityRef, Status } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { type AnyAction, type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type KnowledgeBase } from "./types";

export enum Actions {
  InitBegin = "KNOWLEDGE_BASE_INIT_BEGIN",
  InitFailure = "KNOWLEDGE_BASE_INIT_FAILURE",
  InitSuccess = "KNOWLEDGE_BASE_INIT_SUCCESS",

  SetActiveItem = "KNOWLEDGE_BASE_SET_ACTIVE_ITEM",

  LoadContentBegin = "KNOWLEDGE_BASE_LOAD_CONTENT_BEGIN",
  LoadContentFailure = "KNOWLEDGE_BASE_LOAD_CONTENT_FAILURE",
  LoadContentSuccess = "KNOWLEDGE_BASE_LOAD_CONTENT_SUCCESS"
}

export type InitBeginActionData = EntityRef & {};
const _init = initAction<AppState, InitBeginActionData, KnowledgeBase.Api.InitResponse>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.init(apiInfo);
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();

  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};

export type LoadContentArgs = EntityRef & {
  articleId: string;
};
const _loadContent = initAction<AppState, LoadContentArgs, string>({
  types: {
    begin: Actions.LoadContentBegin,
    failure: Actions.LoadContentFailure,
    success: Actions.LoadContentSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: LoadContentArgs) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.getContent(apiInfo, args.articleId);
  }
});

export type SetActiveItemArgs = EntityRef & {
  activeItem: KnowledgeBase.View.ActiveItem | null;
};
export const setActiveItem = (args: SetActiveItemArgs) => (dispatch: Dispatch<any>) => {
  dispatch({
    type: Actions.SetActiveItem,
    data: args
  });

  if (args.activeItem?.type === "article" && args.activeItem.article.articleId) {
    dispatch(_loadContent({ id: args.id, source: args.source, articleId: args.activeItem.article.articleId }));
  }
};
